import type { ComponentSettingsState } from '../slices/component-settings-slice';
import componentSettingsSlice from '../slices/component-settings-slice';

export const getSetComponentSettingsAction = (
  settings: ComponentSettingsState,
) => componentSettingsSlice.actions.setComponentSettings(settings);
